import axios from "axios";
import {ADMIN_HOST} from "../../core/variables";

class ScenarioRepository{
    async readScenarios() {
        return axios.get(`${ADMIN_HOST}/v1/cm/scenario`);
    }
}

export default new ScenarioRepository();